import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/ui/Modal';
import { WarningIcon } from 'components/ui/AlertBox/AlertBox.styles';
import { TitleContainer, IconContainer } from '../WarningCta/WarningCta.styles';
import { CancelButton, ConfirmButton } from 'components/ui/Button';
import { StyledButtonWrapper } from '../ExchangeCta/ExchangeCtaOverride.styles';
import { ModalBottomRow } from 'components/ui/Modal/Modal.styles';

export const InsuranceModal = ({ title = '', subtitle = '', onConfirmClick, isOpen, onClose }) => (
  <>
    <Modal
      isOpen={isOpen}
      title={
        <TitleContainer>
          <IconContainer>
            <WarningIcon />
          </IconContainer>
          {title}
        </TitleContainer>
      }
      onClose={onClose}
    >
      <div>
        <FormattedMessage id="exchanges.insuranceWarning.title" /> - <FormattedMessage id={subtitle} />
      </div>

      <ModalBottomRow>
        <StyledButtonWrapper>
          <ConfirmButton data-testid="confirm-after-warning" data-cy="confirm-after-warning" onClick={onConfirmClick}>
            <FormattedMessage id="bookingDetails.confirm" />
          </ConfirmButton>

          <CancelButton type="button" data-cy="cancel-after-warning" data-testid="cancel-after-warning" onClick={onClose}>
            <FormattedMessage id="manageBooking.cancel" />
          </CancelButton>
        </StyledButtonWrapper>
      </ModalBottomRow>
    </Modal>
  </>
);

InsuranceModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  subtitle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  isOpen: PropTypes.bool,
  onConfirmClick: PropTypes.func,
  onClose: PropTypes.func
};
